<cmps-user-info
    class="cmps-coaching-detail-pillar-one--user-info-user"
    [hideImageAndSvgIcon]="true"
    [username]="state?.user?.name"
    (usernameClick)="_onUsernameClick()"
    *ngIf="!state?.pending?.reloadUser && state?.user?.name"
>
    <ng-template cmpsUserInfoLabels>
        <div
            cmpsUserInfoLabel
            *ngIf="state?.user?.superGroupName"
        >
            {{ _i18n._9552_SG_ | translate }} {{ state?.user?.superGroupName }}
        </div>
        <div
            cmpsUserInfoLabel
            *ngIf="state?.user?.managerName"
        >
            {{ _i18n._9553_MANAGER_ | translate }}
            {{ state?.user?.managerName }}
        </div>
    </ng-template>
</cmps-user-info>

<cmps-accordion
    class="cmps-coaching-detail--pillar-one--pad"
    theme="b"
    [multi]="true"
    *ngIf="!state?.pending?.reload"
>
    <cmps-accordion-item [isOpen]="true">
        <cmps-accordion-header>
            {{ _i18n._9549_OPPORTUNITY_COACHING | translate }} ({{
                state?.numOpportunities
            }})
        </cmps-accordion-header>
        <cmps-accordion-content>
            <cmps-accordion [multi]="true">
                <ng-container *ngFor="let c of state?.oppCategories">
                    <cmps-accordion-item [isOpen]="c?.isOpen">
                        <cmps-accordion-header
                            >{{ c?.label | translate }} ({{
                                c?.items?.length
                            }})</cmps-accordion-header
                        >
                        <cmps-accordion-content>
                            <ng-container *ngFor="let i of c?.items">
                                <ng-container
                                    *ngTemplateOutlet="
                                        oppBtnTpl;
                                        context: { $implicit: i }
                                    "
                                ></ng-container>
                            </ng-container>
                        </cmps-accordion-content>
                    </cmps-accordion-item>
                </ng-container>
            </cmps-accordion>
        </cmps-accordion-content>
    </cmps-accordion-item>
    <cmps-accordion-item [isOpen]="state?.nonOpportunitiesOpen">
        <cmps-accordion-header>
            {{ _i18n._9550_NON_OPPORTUNITY_KPI_GOAL_COACHING | translate }} ({{
                state?.nonOpportunities?.length
            }})
        </cmps-accordion-header>
        <cmps-accordion-content>
            <ng-container *ngFor="let i of state?.nonOpportunities">
                <ng-container
                    *ngTemplateOutlet="oppBtnTpl; context: { $implicit: i }"
                ></ng-container>
            </ng-container>
        </cmps-accordion-content>
    </cmps-accordion-item>
    <cmps-accordion-item [isOpen]="state?.nonKpisOpen">
        <cmps-accordion-header>
            {{ _i18n._9551_NON_KPI_GOAL_COACHING | translate }} ({{
                state?.nonKpis?.length
            }})
        </cmps-accordion-header>
        <cmps-accordion-content>
            <ng-container *ngFor="let i of state?.nonKpis">
                <button
                    cmpsCoachingFocusLabelButton
                    [statusLabel]="i.status | translate"
                    [behaviourLabel]="_i18n._9525_B_ | translate"
                    [behaviour]="i.behaviour"
                    [subBehaviourLabel]="_i18n._9526_S_B_ | translate"
                    [subBehaviour]="i.subBehaviour"
                    (click)="_onFocusLabelClick(i)"
                ></button>
            </ng-container>
        </cmps-accordion-content>
    </cmps-accordion-item>
</cmps-accordion>

<ng-template
    #oppBtnTpl
    let-i
>
    <div class="cmps-coaching-detail-pillar-one--opp-button-wrapper">
        <button
            cmpsCoachingOppItemButton
            [label]="i.label | translate"
            [goalBorderColour]="i.goalBorderColour"
            [goalColour]="i.goalColour"
            [goalLabel]="
                (i.goalLabel | translate) ||
                (i.percentToGoal == null
                    ? null
                    : (i.percentToGoal | cmpsPercentWithSuffix: '1.0-0'))
            "
            [goalLabelColour]="i.goalLabelColour"
            [goalIcon]="i.goalIcon"
            [goalBadgeColour]="i.goalBadgeColour"
            [goalBadgeLabel]="i.goalBadgeLabel"
            [goalBadgeLabelColour]="i.goalBadgeLabelColour"
            [targetColour]="i.targetColour"
            [targetLabel]="
                (i.targetLabel | translate) ||
                (i.percentToTarget == null
                    ? null
                    : (i.percentToTarget | cmpsPercentWithSuffix: '1.0-0'))
            "
            [active]="i.metricId === state?.metricId"
            (click)="_onOppItemClick(i)"
        ></button>
        <div
            class="cmps-coaching-detail-pillar-one--active-metric"
            *ngIf="
                i.metricId === state?.metricId && state?.metricIdIsInMultiple
            "
        ></div>
    </div>
</ng-template>
